import SwitchContainer from './SwitchContainer';

export default SwitchContainer;
